import * as Types from './operations';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const ValidateTokenDocument = gql`
    query ValidateToken {
  validateToken
}
    `;

/**
 * __useValidateTokenQuery__
 *
 * To run a query within a React component, call `useValidateTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useValidateTokenQuery(baseOptions?: Apollo.QueryHookOptions<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>(ValidateTokenDocument, options);
      }
export function useValidateTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>(ValidateTokenDocument, options);
        }
export function useValidateTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>(ValidateTokenDocument, options);
        }
export type ValidateTokenQueryHookResult = ReturnType<typeof useValidateTokenQuery>;
export type ValidateTokenLazyQueryHookResult = ReturnType<typeof useValidateTokenLazyQuery>;
export type ValidateTokenSuspenseQueryHookResult = ReturnType<typeof useValidateTokenSuspenseQuery>;
export type ValidateTokenQueryResult = Apollo.QueryResult<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>;
export const PortalLoginDocument = gql`
    mutation PortalLogin($email: String!, $password: String!) {
  portalLogin(password: $password, email: $email) {
    accessToken
    expiresIn
    refreshToken
    tokenType
  }
}
    `;
export type PortalLoginMutationFn = Apollo.MutationFunction<Types.PortalLoginMutation, Types.PortalLoginMutationVariables>;

/**
 * __usePortalLoginMutation__
 *
 * To run a mutation, you first call `usePortalLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalLoginMutation, { data, loading, error }] = usePortalLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function usePortalLoginMutation(baseOptions?: Apollo.MutationHookOptions<Types.PortalLoginMutation, Types.PortalLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PortalLoginMutation, Types.PortalLoginMutationVariables>(PortalLoginDocument, options);
      }
export type PortalLoginMutationHookResult = ReturnType<typeof usePortalLoginMutation>;
export type PortalLoginMutationResult = Apollo.MutationResult<Types.PortalLoginMutation>;
export type PortalLoginMutationOptions = Apollo.BaseMutationOptions<Types.PortalLoginMutation, Types.PortalLoginMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    accessToken
    expiresIn
    refreshToken
    tokenType
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<Types.RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout($refreshToken: String!) {
  logout(refreshToken: $refreshToken)
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<Types.LogoutMutation, Types.LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<Types.LogoutMutation, Types.LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LogoutMutation, Types.LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<Types.LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<Types.LogoutMutation, Types.LogoutMutationVariables>;
export const GetAllDriversDocument = gql`
    query GetAllDrivers {
  getAllDrivers {
    hasMore
    limit
    offset
    total
    drivers {
      email
      gender
      id
      name
      phoneNumber
      driverInfo {
        registrationStatus
      }
    }
  }
}
    `;

/**
 * __useGetAllDriversQuery__
 *
 * To run a query within a React component, call `useGetAllDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDriversQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDriversQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllDriversQuery, Types.GetAllDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllDriversQuery, Types.GetAllDriversQueryVariables>(GetAllDriversDocument, options);
      }
export function useGetAllDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllDriversQuery, Types.GetAllDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllDriversQuery, Types.GetAllDriversQueryVariables>(GetAllDriversDocument, options);
        }
export function useGetAllDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllDriversQuery, Types.GetAllDriversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllDriversQuery, Types.GetAllDriversQueryVariables>(GetAllDriversDocument, options);
        }
export type GetAllDriversQueryHookResult = ReturnType<typeof useGetAllDriversQuery>;
export type GetAllDriversLazyQueryHookResult = ReturnType<typeof useGetAllDriversLazyQuery>;
export type GetAllDriversSuspenseQueryHookResult = ReturnType<typeof useGetAllDriversSuspenseQuery>;
export type GetAllDriversQueryResult = Apollo.QueryResult<Types.GetAllDriversQuery, Types.GetAllDriversQueryVariables>;
export const AllDriversListDocument = gql`
    query AllDriversList {
  allDriversList {
    id
    name
  }
}
    `;

/**
 * __useAllDriversListQuery__
 *
 * To run a query within a React component, call `useAllDriversListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDriversListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDriversListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDriversListQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllDriversListQuery, Types.AllDriversListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllDriversListQuery, Types.AllDriversListQueryVariables>(AllDriversListDocument, options);
      }
export function useAllDriversListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllDriversListQuery, Types.AllDriversListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllDriversListQuery, Types.AllDriversListQueryVariables>(AllDriversListDocument, options);
        }
export function useAllDriversListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.AllDriversListQuery, Types.AllDriversListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllDriversListQuery, Types.AllDriversListQueryVariables>(AllDriversListDocument, options);
        }
export type AllDriversListQueryHookResult = ReturnType<typeof useAllDriversListQuery>;
export type AllDriversListLazyQueryHookResult = ReturnType<typeof useAllDriversListLazyQuery>;
export type AllDriversListSuspenseQueryHookResult = ReturnType<typeof useAllDriversListSuspenseQuery>;
export type AllDriversListQueryResult = Apollo.QueryResult<Types.AllDriversListQuery, Types.AllDriversListQueryVariables>;
export const UpdateDriverStatusByUserIdDocument = gql`
    mutation UpdateDriverStatusByUserId($input: UpdateDriverStatusDto!) {
  updateDriverStatusByUserId(input: $input) {
    createdAt
    email
    id
    idNumber
    idType
    isVehicleOwner
    registrationStatus
    rejectionReason
    updatedAt
  }
}
    `;
export type UpdateDriverStatusByUserIdMutationFn = Apollo.MutationFunction<Types.UpdateDriverStatusByUserIdMutation, Types.UpdateDriverStatusByUserIdMutationVariables>;

/**
 * __useUpdateDriverStatusByUserIdMutation__
 *
 * To run a mutation, you first call `useUpdateDriverStatusByUserIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverStatusByUserIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverStatusByUserIdMutation, { data, loading, error }] = useUpdateDriverStatusByUserIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDriverStatusByUserIdMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDriverStatusByUserIdMutation, Types.UpdateDriverStatusByUserIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDriverStatusByUserIdMutation, Types.UpdateDriverStatusByUserIdMutationVariables>(UpdateDriverStatusByUserIdDocument, options);
      }
export type UpdateDriverStatusByUserIdMutationHookResult = ReturnType<typeof useUpdateDriverStatusByUserIdMutation>;
export type UpdateDriverStatusByUserIdMutationResult = Apollo.MutationResult<Types.UpdateDriverStatusByUserIdMutation>;
export type UpdateDriverStatusByUserIdMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDriverStatusByUserIdMutation, Types.UpdateDriverStatusByUserIdMutationVariables>;
export const UpdateDriverDocumentStatusDocument = gql`
    mutation UpdateDriverDocumentStatus($input: UpdateDriverDocumentStatusDto!, $userId: Int!) {
  updateDriverDocumentStatus(input: $input, userId: $userId) {
    ... on DriverIdentity {
      birthDate
      createdAt
      firstNameAr
      firstNameEn
      gender
      id
      lastNameAr
      lastNameEn
      rejectionReason
      status
      updatedAt
    }
    ... on DriverLicense {
      createdAt
      expirationDate
      id
      licenseNumber
      rejectionReason
      status
      updatedAt
    }
    ... on DriverProfilePicture {
      createdAt
      id
      rejectionReason
      status
      updatedAt
    }
    ... on DriverVehicleRegistration {
      createdAt
      id
      ownerId
      plateNumber
      rejectionReason
      serialNumber
      status
      updatedAt
      vehicleBrand
      visaUserId
    }
  }
}
    `;
export type UpdateDriverDocumentStatusMutationFn = Apollo.MutationFunction<Types.UpdateDriverDocumentStatusMutation, Types.UpdateDriverDocumentStatusMutationVariables>;

/**
 * __useUpdateDriverDocumentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDriverDocumentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverDocumentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverDocumentStatusMutation, { data, loading, error }] = useUpdateDriverDocumentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateDriverDocumentStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDriverDocumentStatusMutation, Types.UpdateDriverDocumentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDriverDocumentStatusMutation, Types.UpdateDriverDocumentStatusMutationVariables>(UpdateDriverDocumentStatusDocument, options);
      }
export type UpdateDriverDocumentStatusMutationHookResult = ReturnType<typeof useUpdateDriverDocumentStatusMutation>;
export type UpdateDriverDocumentStatusMutationResult = Apollo.MutationResult<Types.UpdateDriverDocumentStatusMutation>;
export type UpdateDriverDocumentStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDriverDocumentStatusMutation, Types.UpdateDriverDocumentStatusMutationVariables>;
export const GetDriverByIdDocument = gql`
    query GetDriverById($userId: Int!) {
  getDriverById(userId: $userId) {
    email
    id
    name
    phoneNumber
    driverInfo {
      email
      id
      idNumber
      idType
      isVehicleOwner
      registrationStatus
      rejectionReason
      deliveryArea {
        nameAr
        nameEn
      }
      nationality {
        name
        nameAr
      }
      vehicleType {
        nameAr
        nameEn
      }
    }
    driverIdentity {
      birthDate
      firstNameAr
      firstNameEn
      gender
      id
      lastNameAr
      lastNameEn
      image {
        url
        fileName
      }
      status
      rejectionReason
    }
    driverLicense {
      expirationDate
      id
      licenseNumber
      updatedAt
      image {
        originalName
        url
      }
      status
      rejectionReason
    }
    driverProfilePicture {
      image {
        originalName
        url
      }
      status
      rejectionReason
    }
    driverVehicleRegistration {
      ownerId
      plateNumber
      serialNumber
      vehicleBrand
      visaUserId
      image {
        originalName
        url
      }
      status
      rejectionReason
    }
  }
}
    `;

/**
 * __useGetDriverByIdQuery__
 *
 * To run a query within a React component, call `useGetDriverByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetDriverByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDriverByIdQuery, Types.GetDriverByIdQueryVariables> & ({ variables: Types.GetDriverByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDriverByIdQuery, Types.GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
      }
export function useGetDriverByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDriverByIdQuery, Types.GetDriverByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDriverByIdQuery, Types.GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
        }
export function useGetDriverByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetDriverByIdQuery, Types.GetDriverByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDriverByIdQuery, Types.GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
        }
export type GetDriverByIdQueryHookResult = ReturnType<typeof useGetDriverByIdQuery>;
export type GetDriverByIdLazyQueryHookResult = ReturnType<typeof useGetDriverByIdLazyQuery>;
export type GetDriverByIdSuspenseQueryHookResult = ReturnType<typeof useGetDriverByIdSuspenseQuery>;
export type GetDriverByIdQueryResult = Apollo.QueryResult<Types.GetDriverByIdQuery, Types.GetDriverByIdQueryVariables>;
export const AllBeneficiariesDocument = gql`
    query AllBeneficiaries($pagination: PaginationInput, $filter: BeneficiaryFilterInput) {
  allBeneficiaries(pagination: $pagination, filter: $filter) {
    hasMore
    limit
    offset
    total
    beneficiaries {
      bank
      bankCode
      iban
      id
      name
      status
      ibanPhoto {
        url
      }
    }
  }
}
    `;

/**
 * __useAllBeneficiariesQuery__
 *
 * To run a query within a React component, call `useAllBeneficiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBeneficiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBeneficiariesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllBeneficiariesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllBeneficiariesQuery, Types.AllBeneficiariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllBeneficiariesQuery, Types.AllBeneficiariesQueryVariables>(AllBeneficiariesDocument, options);
      }
export function useAllBeneficiariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllBeneficiariesQuery, Types.AllBeneficiariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllBeneficiariesQuery, Types.AllBeneficiariesQueryVariables>(AllBeneficiariesDocument, options);
        }
export function useAllBeneficiariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.AllBeneficiariesQuery, Types.AllBeneficiariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllBeneficiariesQuery, Types.AllBeneficiariesQueryVariables>(AllBeneficiariesDocument, options);
        }
export type AllBeneficiariesQueryHookResult = ReturnType<typeof useAllBeneficiariesQuery>;
export type AllBeneficiariesLazyQueryHookResult = ReturnType<typeof useAllBeneficiariesLazyQuery>;
export type AllBeneficiariesSuspenseQueryHookResult = ReturnType<typeof useAllBeneficiariesSuspenseQuery>;
export type AllBeneficiariesQueryResult = Apollo.QueryResult<Types.AllBeneficiariesQuery, Types.AllBeneficiariesQueryVariables>;
export const UpdateBeneficiaryStatusDocument = gql`
    mutation UpdateBeneficiaryStatus($input: UpdateBeneficiaryStatusDto!) {
  updateBeneficiaryStatus(input: $input) {
    bank
    bankCode
    createdAt
    iban
    id
    name
    status
    updatedAt
  }
}
    `;
export type UpdateBeneficiaryStatusMutationFn = Apollo.MutationFunction<Types.UpdateBeneficiaryStatusMutation, Types.UpdateBeneficiaryStatusMutationVariables>;

/**
 * __useUpdateBeneficiaryStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBeneficiaryStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBeneficiaryStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBeneficiaryStatusMutation, { data, loading, error }] = useUpdateBeneficiaryStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBeneficiaryStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateBeneficiaryStatusMutation, Types.UpdateBeneficiaryStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateBeneficiaryStatusMutation, Types.UpdateBeneficiaryStatusMutationVariables>(UpdateBeneficiaryStatusDocument, options);
      }
export type UpdateBeneficiaryStatusMutationHookResult = ReturnType<typeof useUpdateBeneficiaryStatusMutation>;
export type UpdateBeneficiaryStatusMutationResult = Apollo.MutationResult<Types.UpdateBeneficiaryStatusMutation>;
export type UpdateBeneficiaryStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateBeneficiaryStatusMutation, Types.UpdateBeneficiaryStatusMutationVariables>;
export const AllWithdrawalsDocument = gql`
    query AllWithdrawals($pagination: PaginationInput, $filter: WithdrawalFilterInput) {
  allWithdrawals(pagination: $pagination, filter: $filter) {
    withdrawals {
      id
      amountMinor
      status
      description
      rejectionReason
      balanceAtTime
      createdAt
      updatedAt
      driver {
        id
        name
        phoneNumber
        email
      }
      beneficiary {
        id
        name
        iban
        bank
        bankCode
      }
    }
    total
    hasMore
    limit
    offset
  }
}
    `;

/**
 * __useAllWithdrawalsQuery__
 *
 * To run a query within a React component, call `useAllWithdrawalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWithdrawalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWithdrawalsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllWithdrawalsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllWithdrawalsQuery, Types.AllWithdrawalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllWithdrawalsQuery, Types.AllWithdrawalsQueryVariables>(AllWithdrawalsDocument, options);
      }
export function useAllWithdrawalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllWithdrawalsQuery, Types.AllWithdrawalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllWithdrawalsQuery, Types.AllWithdrawalsQueryVariables>(AllWithdrawalsDocument, options);
        }
export function useAllWithdrawalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.AllWithdrawalsQuery, Types.AllWithdrawalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllWithdrawalsQuery, Types.AllWithdrawalsQueryVariables>(AllWithdrawalsDocument, options);
        }
export type AllWithdrawalsQueryHookResult = ReturnType<typeof useAllWithdrawalsQuery>;
export type AllWithdrawalsLazyQueryHookResult = ReturnType<typeof useAllWithdrawalsLazyQuery>;
export type AllWithdrawalsSuspenseQueryHookResult = ReturnType<typeof useAllWithdrawalsSuspenseQuery>;
export type AllWithdrawalsQueryResult = Apollo.QueryResult<Types.AllWithdrawalsQuery, Types.AllWithdrawalsQueryVariables>;
export const UpdateWithdrawalStatusDocument = gql`
    mutation UpdateWithdrawalStatus($input: UpdateWithdrawalStatusDto!) {
  updateWithdrawalStatus(input: $input) {
    id
    amountMinor
    status
    driver {
      id
      name
    }
    beneficiary {
      name
      iban
    }
    updatedAt
  }
}
    `;
export type UpdateWithdrawalStatusMutationFn = Apollo.MutationFunction<Types.UpdateWithdrawalStatusMutation, Types.UpdateWithdrawalStatusMutationVariables>;

/**
 * __useUpdateWithdrawalStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWithdrawalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWithdrawalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWithdrawalStatusMutation, { data, loading, error }] = useUpdateWithdrawalStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWithdrawalStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateWithdrawalStatusMutation, Types.UpdateWithdrawalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateWithdrawalStatusMutation, Types.UpdateWithdrawalStatusMutationVariables>(UpdateWithdrawalStatusDocument, options);
      }
export type UpdateWithdrawalStatusMutationHookResult = ReturnType<typeof useUpdateWithdrawalStatusMutation>;
export type UpdateWithdrawalStatusMutationResult = Apollo.MutationResult<Types.UpdateWithdrawalStatusMutation>;
export type UpdateWithdrawalStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateWithdrawalStatusMutation, Types.UpdateWithdrawalStatusMutationVariables>;
export const GetAllFinanceTreeDocument = gql`
    query GetAllFinanceTree {
  getAllFinanceTreeItemsWithLevel {
    id
    serialNumber
    name
    nameAr
    slug
    editable
    parentId
    level
    balance
    totalCredit
    totalDebit
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAllFinanceTreeQuery__
 *
 * To run a query within a React component, call `useGetAllFinanceTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFinanceTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFinanceTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllFinanceTreeQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllFinanceTreeQuery, Types.GetAllFinanceTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllFinanceTreeQuery, Types.GetAllFinanceTreeQueryVariables>(GetAllFinanceTreeDocument, options);
      }
export function useGetAllFinanceTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllFinanceTreeQuery, Types.GetAllFinanceTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllFinanceTreeQuery, Types.GetAllFinanceTreeQueryVariables>(GetAllFinanceTreeDocument, options);
        }
export function useGetAllFinanceTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllFinanceTreeQuery, Types.GetAllFinanceTreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllFinanceTreeQuery, Types.GetAllFinanceTreeQueryVariables>(GetAllFinanceTreeDocument, options);
        }
export type GetAllFinanceTreeQueryHookResult = ReturnType<typeof useGetAllFinanceTreeQuery>;
export type GetAllFinanceTreeLazyQueryHookResult = ReturnType<typeof useGetAllFinanceTreeLazyQuery>;
export type GetAllFinanceTreeSuspenseQueryHookResult = ReturnType<typeof useGetAllFinanceTreeSuspenseQuery>;
export type GetAllFinanceTreeQueryResult = Apollo.QueryResult<Types.GetAllFinanceTreeQuery, Types.GetAllFinanceTreeQueryVariables>;
export const CreateFinanceTreeItemDocument = gql`
    mutation CreateFinanceTreeItem($name: String!, $nameAr: String!, $parentId: Int, $editable: Boolean) {
  createFinanceTreeItem(
    createFinanceTreeDto: {name: $name, nameAr: $nameAr, parentId: $parentId, editable: $editable}
  ) {
    id
    serialNumber
    name
    nameAr
    slug
    editable
    parentId
    level
    createdAt
    updatedAt
  }
}
    `;
export type CreateFinanceTreeItemMutationFn = Apollo.MutationFunction<Types.CreateFinanceTreeItemMutation, Types.CreateFinanceTreeItemMutationVariables>;

/**
 * __useCreateFinanceTreeItemMutation__
 *
 * To run a mutation, you first call `useCreateFinanceTreeItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinanceTreeItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinanceTreeItemMutation, { data, loading, error }] = useCreateFinanceTreeItemMutation({
 *   variables: {
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      parentId: // value for 'parentId'
 *      editable: // value for 'editable'
 *   },
 * });
 */
export function useCreateFinanceTreeItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFinanceTreeItemMutation, Types.CreateFinanceTreeItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFinanceTreeItemMutation, Types.CreateFinanceTreeItemMutationVariables>(CreateFinanceTreeItemDocument, options);
      }
export type CreateFinanceTreeItemMutationHookResult = ReturnType<typeof useCreateFinanceTreeItemMutation>;
export type CreateFinanceTreeItemMutationResult = Apollo.MutationResult<Types.CreateFinanceTreeItemMutation>;
export type CreateFinanceTreeItemMutationOptions = Apollo.BaseMutationOptions<Types.CreateFinanceTreeItemMutation, Types.CreateFinanceTreeItemMutationVariables>;
export const UpdateFinanceTreeItemDocument = gql`
    mutation UpdateFinanceTreeItem($id: Int!, $name: String, $nameAr: String, $editable: Boolean) {
  updateFinanceTreeItem(
    id: $id
    updateFinanceTreeDto: {name: $name, nameAr: $nameAr, editable: $editable}
  ) {
    id
    serialNumber
    name
    nameAr
    slug
    editable
    parentId
    level
    createdAt
    updatedAt
  }
}
    `;
export type UpdateFinanceTreeItemMutationFn = Apollo.MutationFunction<Types.UpdateFinanceTreeItemMutation, Types.UpdateFinanceTreeItemMutationVariables>;

/**
 * __useUpdateFinanceTreeItemMutation__
 *
 * To run a mutation, you first call `useUpdateFinanceTreeItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinanceTreeItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinanceTreeItemMutation, { data, loading, error }] = useUpdateFinanceTreeItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      editable: // value for 'editable'
 *   },
 * });
 */
export function useUpdateFinanceTreeItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFinanceTreeItemMutation, Types.UpdateFinanceTreeItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFinanceTreeItemMutation, Types.UpdateFinanceTreeItemMutationVariables>(UpdateFinanceTreeItemDocument, options);
      }
export type UpdateFinanceTreeItemMutationHookResult = ReturnType<typeof useUpdateFinanceTreeItemMutation>;
export type UpdateFinanceTreeItemMutationResult = Apollo.MutationResult<Types.UpdateFinanceTreeItemMutation>;
export type UpdateFinanceTreeItemMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFinanceTreeItemMutation, Types.UpdateFinanceTreeItemMutationVariables>;
export const DeleteFinanceTreeItemDocument = gql`
    mutation DeleteFinanceTreeItem($id: Int!) {
  deleteFinanceTreeItem(id: $id)
}
    `;
export type DeleteFinanceTreeItemMutationFn = Apollo.MutationFunction<Types.DeleteFinanceTreeItemMutation, Types.DeleteFinanceTreeItemMutationVariables>;

/**
 * __useDeleteFinanceTreeItemMutation__
 *
 * To run a mutation, you first call `useDeleteFinanceTreeItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFinanceTreeItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFinanceTreeItemMutation, { data, loading, error }] = useDeleteFinanceTreeItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFinanceTreeItemMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFinanceTreeItemMutation, Types.DeleteFinanceTreeItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFinanceTreeItemMutation, Types.DeleteFinanceTreeItemMutationVariables>(DeleteFinanceTreeItemDocument, options);
      }
export type DeleteFinanceTreeItemMutationHookResult = ReturnType<typeof useDeleteFinanceTreeItemMutation>;
export type DeleteFinanceTreeItemMutationResult = Apollo.MutationResult<Types.DeleteFinanceTreeItemMutation>;
export type DeleteFinanceTreeItemMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFinanceTreeItemMutation, Types.DeleteFinanceTreeItemMutationVariables>;
export const GetAllFinanceTreeTransactionLinesDocument = gql`
    query GetAllFinanceTreeTransactionLines($limit: Int!, $page: Int!, $filter: FinanceTreeTransactionLineFilterDto) {
  getAllFinanceTreeTransactionLines(limit: $limit, page: $page, filter: $filter) {
    limit
    page
    total
    totalPages
    transactionLines {
      id
      transactionId
      financeTreeId
      debit
      credit
      description
      createdAt
      updatedAt
      financeTree {
        id
        name
        nameAr
      }
    }
  }
}
    `;

/**
 * __useGetAllFinanceTreeTransactionLinesQuery__
 *
 * To run a query within a React component, call `useGetAllFinanceTreeTransactionLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFinanceTreeTransactionLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFinanceTreeTransactionLinesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllFinanceTreeTransactionLinesQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAllFinanceTreeTransactionLinesQuery, Types.GetAllFinanceTreeTransactionLinesQueryVariables> & ({ variables: Types.GetAllFinanceTreeTransactionLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllFinanceTreeTransactionLinesQuery, Types.GetAllFinanceTreeTransactionLinesQueryVariables>(GetAllFinanceTreeTransactionLinesDocument, options);
      }
export function useGetAllFinanceTreeTransactionLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllFinanceTreeTransactionLinesQuery, Types.GetAllFinanceTreeTransactionLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllFinanceTreeTransactionLinesQuery, Types.GetAllFinanceTreeTransactionLinesQueryVariables>(GetAllFinanceTreeTransactionLinesDocument, options);
        }
export function useGetAllFinanceTreeTransactionLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllFinanceTreeTransactionLinesQuery, Types.GetAllFinanceTreeTransactionLinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllFinanceTreeTransactionLinesQuery, Types.GetAllFinanceTreeTransactionLinesQueryVariables>(GetAllFinanceTreeTransactionLinesDocument, options);
        }
export type GetAllFinanceTreeTransactionLinesQueryHookResult = ReturnType<typeof useGetAllFinanceTreeTransactionLinesQuery>;
export type GetAllFinanceTreeTransactionLinesLazyQueryHookResult = ReturnType<typeof useGetAllFinanceTreeTransactionLinesLazyQuery>;
export type GetAllFinanceTreeTransactionLinesSuspenseQueryHookResult = ReturnType<typeof useGetAllFinanceTreeTransactionLinesSuspenseQuery>;
export type GetAllFinanceTreeTransactionLinesQueryResult = Apollo.QueryResult<Types.GetAllFinanceTreeTransactionLinesQuery, Types.GetAllFinanceTreeTransactionLinesQueryVariables>;
export const GetMaintenanceStatusDocument = gql`
    query GetMaintenanceStatus {
  maintenanceStatus {
    isUnderMaintenance
  }
}
    `;

/**
 * __useGetMaintenanceStatusQuery__
 *
 * To run a query within a React component, call `useGetMaintenanceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaintenanceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaintenanceStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMaintenanceStatusQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetMaintenanceStatusQuery, Types.GetMaintenanceStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMaintenanceStatusQuery, Types.GetMaintenanceStatusQueryVariables>(GetMaintenanceStatusDocument, options);
      }
export function useGetMaintenanceStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMaintenanceStatusQuery, Types.GetMaintenanceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMaintenanceStatusQuery, Types.GetMaintenanceStatusQueryVariables>(GetMaintenanceStatusDocument, options);
        }
export function useGetMaintenanceStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMaintenanceStatusQuery, Types.GetMaintenanceStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMaintenanceStatusQuery, Types.GetMaintenanceStatusQueryVariables>(GetMaintenanceStatusDocument, options);
        }
export type GetMaintenanceStatusQueryHookResult = ReturnType<typeof useGetMaintenanceStatusQuery>;
export type GetMaintenanceStatusLazyQueryHookResult = ReturnType<typeof useGetMaintenanceStatusLazyQuery>;
export type GetMaintenanceStatusSuspenseQueryHookResult = ReturnType<typeof useGetMaintenanceStatusSuspenseQuery>;
export type GetMaintenanceStatusQueryResult = Apollo.QueryResult<Types.GetMaintenanceStatusQuery, Types.GetMaintenanceStatusQueryVariables>;
export const EnableMaintenanceModeDocument = gql`
    mutation EnableMaintenanceMode {
  setMaintenanceMode(input: {enabled: true}) {
    isUnderMaintenance
  }
}
    `;
export type EnableMaintenanceModeMutationFn = Apollo.MutationFunction<Types.EnableMaintenanceModeMutation, Types.EnableMaintenanceModeMutationVariables>;

/**
 * __useEnableMaintenanceModeMutation__
 *
 * To run a mutation, you first call `useEnableMaintenanceModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableMaintenanceModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableMaintenanceModeMutation, { data, loading, error }] = useEnableMaintenanceModeMutation({
 *   variables: {
 *   },
 * });
 */
export function useEnableMaintenanceModeMutation(baseOptions?: Apollo.MutationHookOptions<Types.EnableMaintenanceModeMutation, Types.EnableMaintenanceModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EnableMaintenanceModeMutation, Types.EnableMaintenanceModeMutationVariables>(EnableMaintenanceModeDocument, options);
      }
export type EnableMaintenanceModeMutationHookResult = ReturnType<typeof useEnableMaintenanceModeMutation>;
export type EnableMaintenanceModeMutationResult = Apollo.MutationResult<Types.EnableMaintenanceModeMutation>;
export type EnableMaintenanceModeMutationOptions = Apollo.BaseMutationOptions<Types.EnableMaintenanceModeMutation, Types.EnableMaintenanceModeMutationVariables>;
export const DisableMaintenanceModeDocument = gql`
    mutation DisableMaintenanceMode {
  setMaintenanceMode(input: {enabled: false}) {
    isUnderMaintenance
  }
}
    `;
export type DisableMaintenanceModeMutationFn = Apollo.MutationFunction<Types.DisableMaintenanceModeMutation, Types.DisableMaintenanceModeMutationVariables>;

/**
 * __useDisableMaintenanceModeMutation__
 *
 * To run a mutation, you first call `useDisableMaintenanceModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableMaintenanceModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableMaintenanceModeMutation, { data, loading, error }] = useDisableMaintenanceModeMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableMaintenanceModeMutation(baseOptions?: Apollo.MutationHookOptions<Types.DisableMaintenanceModeMutation, Types.DisableMaintenanceModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DisableMaintenanceModeMutation, Types.DisableMaintenanceModeMutationVariables>(DisableMaintenanceModeDocument, options);
      }
export type DisableMaintenanceModeMutationHookResult = ReturnType<typeof useDisableMaintenanceModeMutation>;
export type DisableMaintenanceModeMutationResult = Apollo.MutationResult<Types.DisableMaintenanceModeMutation>;
export type DisableMaintenanceModeMutationOptions = Apollo.BaseMutationOptions<Types.DisableMaintenanceModeMutation, Types.DisableMaintenanceModeMutationVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($base64File: String!, $originalName: String!, $altText: String, $description: String, $tags: [String!], $folder: String) {
  uploadFile(
    base64File: $base64File
    originalName: $originalName
    altText: $altText
    description: $description
    tags: $tags
    folder: $folder
  ) {
    id
    url
    fileName
    originalName
    mimeType
    size
    altText
    description
    tags
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<Types.UploadFileMutation, Types.UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      base64File: // value for 'base64File'
 *      originalName: // value for 'originalName'
 *      altText: // value for 'altText'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<Types.UploadFileMutation, Types.UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UploadFileMutation, Types.UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<Types.UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<Types.UploadFileMutation, Types.UploadFileMutationVariables>;
export const GetMediaByIdDocument = gql`
    query GetMediaById($id: Int!) {
  getMediaById(id: $id) {
    id
    url
    fileName
    originalName
    mimeType
    size
    altText
    description
    tags
  }
}
    `;

/**
 * __useGetMediaByIdQuery__
 *
 * To run a query within a React component, call `useGetMediaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMediaByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables> & ({ variables: Types.GetMediaByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>(GetMediaByIdDocument, options);
      }
export function useGetMediaByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>(GetMediaByIdDocument, options);
        }
export function useGetMediaByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>(GetMediaByIdDocument, options);
        }
export type GetMediaByIdQueryHookResult = ReturnType<typeof useGetMediaByIdQuery>;
export type GetMediaByIdLazyQueryHookResult = ReturnType<typeof useGetMediaByIdLazyQuery>;
export type GetMediaByIdSuspenseQueryHookResult = ReturnType<typeof useGetMediaByIdSuspenseQuery>;
export type GetMediaByIdQueryResult = Apollo.QueryResult<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>;
export const DeleteMediaDocument = gql`
    mutation DeleteMedia($id: Int!) {
  deleteMedia(id: $id)
}
    `;
export type DeleteMediaMutationFn = Apollo.MutationFunction<Types.DeleteMediaMutation, Types.DeleteMediaMutationVariables>;

/**
 * __useDeleteMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaMutation, { data, loading, error }] = useDeleteMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMediaMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMediaMutation, Types.DeleteMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMediaMutation, Types.DeleteMediaMutationVariables>(DeleteMediaDocument, options);
      }
export type DeleteMediaMutationHookResult = ReturnType<typeof useDeleteMediaMutation>;
export type DeleteMediaMutationResult = Apollo.MutationResult<Types.DeleteMediaMutation>;
export type DeleteMediaMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMediaMutation, Types.DeleteMediaMutationVariables>;
export const SendNotificationToUserDocument = gql`
    mutation SendNotificationToUser($userIds: [Int!], $titleAr: String!, $titleEn: String!, $bodyAr: String!, $bodyEn: String!, $data: JSONObject!, $imageId: Int) {
  sendNotificationToUser(
    input: {userIds: $userIds, title: {ar: $titleAr, en: $titleEn}, body: {ar: $bodyAr, en: $bodyEn}, data: $data, imageId: $imageId}
  ) {
    success
    successCount
    failureCount
    message
  }
}
    `;
export type SendNotificationToUserMutationFn = Apollo.MutationFunction<Types.SendNotificationToUserMutation, Types.SendNotificationToUserMutationVariables>;

/**
 * __useSendNotificationToUserMutation__
 *
 * To run a mutation, you first call `useSendNotificationToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNotificationToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNotificationToUserMutation, { data, loading, error }] = useSendNotificationToUserMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      titleAr: // value for 'titleAr'
 *      titleEn: // value for 'titleEn'
 *      bodyAr: // value for 'bodyAr'
 *      bodyEn: // value for 'bodyEn'
 *      data: // value for 'data'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useSendNotificationToUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendNotificationToUserMutation, Types.SendNotificationToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendNotificationToUserMutation, Types.SendNotificationToUserMutationVariables>(SendNotificationToUserDocument, options);
      }
export type SendNotificationToUserMutationHookResult = ReturnType<typeof useSendNotificationToUserMutation>;
export type SendNotificationToUserMutationResult = Apollo.MutationResult<Types.SendNotificationToUserMutation>;
export type SendNotificationToUserMutationOptions = Apollo.BaseMutationOptions<Types.SendNotificationToUserMutation, Types.SendNotificationToUserMutationVariables>;
export const GetCustomerUsersDocument = gql`
    query GetCustomerUsers {
  getCustomerUsers {
    id
    phoneNumber
    name
  }
}
    `;

/**
 * __useGetCustomerUsersQuery__
 *
 * To run a query within a React component, call `useGetCustomerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerUsersQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetCustomerUsersQuery, Types.GetCustomerUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCustomerUsersQuery, Types.GetCustomerUsersQueryVariables>(GetCustomerUsersDocument, options);
      }
export function useGetCustomerUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCustomerUsersQuery, Types.GetCustomerUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCustomerUsersQuery, Types.GetCustomerUsersQueryVariables>(GetCustomerUsersDocument, options);
        }
export function useGetCustomerUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetCustomerUsersQuery, Types.GetCustomerUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetCustomerUsersQuery, Types.GetCustomerUsersQueryVariables>(GetCustomerUsersDocument, options);
        }
export type GetCustomerUsersQueryHookResult = ReturnType<typeof useGetCustomerUsersQuery>;
export type GetCustomerUsersLazyQueryHookResult = ReturnType<typeof useGetCustomerUsersLazyQuery>;
export type GetCustomerUsersSuspenseQueryHookResult = ReturnType<typeof useGetCustomerUsersSuspenseQuery>;
export type GetCustomerUsersQueryResult = Apollo.QueryResult<Types.GetCustomerUsersQuery, Types.GetCustomerUsersQueryVariables>;
export const GetAllPartnersTableDocument = gql`
    query GetAllPartnersTable($pagination: PaginationInput) {
  getAllPartnersTable(pagination: $pagination) {
    partners {
      id
      name
      nameAr
      isActive
      storesCount
      partnerCategoriesCount
      plan {
        id
        name
      }
    }
    total
    hasMore
    limit
    offset
  }
}
    `;

/**
 * __useGetAllPartnersTableQuery__
 *
 * To run a query within a React component, call `useGetAllPartnersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPartnersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPartnersTableQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAllPartnersTableQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllPartnersTableQuery, Types.GetAllPartnersTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPartnersTableQuery, Types.GetAllPartnersTableQueryVariables>(GetAllPartnersTableDocument, options);
      }
export function useGetAllPartnersTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPartnersTableQuery, Types.GetAllPartnersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPartnersTableQuery, Types.GetAllPartnersTableQueryVariables>(GetAllPartnersTableDocument, options);
        }
export function useGetAllPartnersTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllPartnersTableQuery, Types.GetAllPartnersTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllPartnersTableQuery, Types.GetAllPartnersTableQueryVariables>(GetAllPartnersTableDocument, options);
        }
export type GetAllPartnersTableQueryHookResult = ReturnType<typeof useGetAllPartnersTableQuery>;
export type GetAllPartnersTableLazyQueryHookResult = ReturnType<typeof useGetAllPartnersTableLazyQuery>;
export type GetAllPartnersTableSuspenseQueryHookResult = ReturnType<typeof useGetAllPartnersTableSuspenseQuery>;
export type GetAllPartnersTableQueryResult = Apollo.QueryResult<Types.GetAllPartnersTableQuery, Types.GetAllPartnersTableQueryVariables>;
export const GetPendingInvitationsByPartnerDocument = gql`
    query GetPendingInvitationsByPartner($partnerId: Int!) {
  getPendingInvitationsByPartner(partnerId: $partnerId) {
    email
    storeName
    createdAt
  }
}
    `;

/**
 * __useGetPendingInvitationsByPartnerQuery__
 *
 * To run a query within a React component, call `useGetPendingInvitationsByPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingInvitationsByPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingInvitationsByPartnerQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetPendingInvitationsByPartnerQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPendingInvitationsByPartnerQuery, Types.GetPendingInvitationsByPartnerQueryVariables> & ({ variables: Types.GetPendingInvitationsByPartnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPendingInvitationsByPartnerQuery, Types.GetPendingInvitationsByPartnerQueryVariables>(GetPendingInvitationsByPartnerDocument, options);
      }
export function useGetPendingInvitationsByPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPendingInvitationsByPartnerQuery, Types.GetPendingInvitationsByPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPendingInvitationsByPartnerQuery, Types.GetPendingInvitationsByPartnerQueryVariables>(GetPendingInvitationsByPartnerDocument, options);
        }
export function useGetPendingInvitationsByPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPendingInvitationsByPartnerQuery, Types.GetPendingInvitationsByPartnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPendingInvitationsByPartnerQuery, Types.GetPendingInvitationsByPartnerQueryVariables>(GetPendingInvitationsByPartnerDocument, options);
        }
export type GetPendingInvitationsByPartnerQueryHookResult = ReturnType<typeof useGetPendingInvitationsByPartnerQuery>;
export type GetPendingInvitationsByPartnerLazyQueryHookResult = ReturnType<typeof useGetPendingInvitationsByPartnerLazyQuery>;
export type GetPendingInvitationsByPartnerSuspenseQueryHookResult = ReturnType<typeof useGetPendingInvitationsByPartnerSuspenseQuery>;
export type GetPendingInvitationsByPartnerQueryResult = Apollo.QueryResult<Types.GetPendingInvitationsByPartnerQuery, Types.GetPendingInvitationsByPartnerQueryVariables>;
export const GetAllPartnersSelectDocument = gql`
    query GetAllPartnersSelect {
  getAllPartners {
    id
    name
    nameAr
  }
}
    `;

/**
 * __useGetAllPartnersSelectQuery__
 *
 * To run a query within a React component, call `useGetAllPartnersSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPartnersSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPartnersSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPartnersSelectQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllPartnersSelectQuery, Types.GetAllPartnersSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPartnersSelectQuery, Types.GetAllPartnersSelectQueryVariables>(GetAllPartnersSelectDocument, options);
      }
export function useGetAllPartnersSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPartnersSelectQuery, Types.GetAllPartnersSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPartnersSelectQuery, Types.GetAllPartnersSelectQueryVariables>(GetAllPartnersSelectDocument, options);
        }
export function useGetAllPartnersSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllPartnersSelectQuery, Types.GetAllPartnersSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllPartnersSelectQuery, Types.GetAllPartnersSelectQueryVariables>(GetAllPartnersSelectDocument, options);
        }
export type GetAllPartnersSelectQueryHookResult = ReturnType<typeof useGetAllPartnersSelectQuery>;
export type GetAllPartnersSelectLazyQueryHookResult = ReturnType<typeof useGetAllPartnersSelectLazyQuery>;
export type GetAllPartnersSelectSuspenseQueryHookResult = ReturnType<typeof useGetAllPartnersSelectSuspenseQuery>;
export type GetAllPartnersSelectQueryResult = Apollo.QueryResult<Types.GetAllPartnersSelectQuery, Types.GetAllPartnersSelectQueryVariables>;
export const CreatePartnerDocument = gql`
    mutation CreatePartner($address: String, $email: String, $name: String!, $nameAr: String!, $phone: String, $planId: Int!, $partnerCategoryIds: [Int!]!, $imageId: Int, $coverImageId: Int) {
  createPartner(
    createPartnerDto: {address: $address, email: $email, name: $name, nameAr: $nameAr, phone: $phone, planId: $planId, partnerCategoryIds: $partnerCategoryIds, imageId: $imageId, coverImageId: $coverImageId}
  ) {
    id
  }
}
    `;
export type CreatePartnerMutationFn = Apollo.MutationFunction<Types.CreatePartnerMutation, Types.CreatePartnerMutationVariables>;

/**
 * __useCreatePartnerMutation__
 *
 * To run a mutation, you first call `useCreatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerMutation, { data, loading, error }] = useCreatePartnerMutation({
 *   variables: {
 *      address: // value for 'address'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      phone: // value for 'phone'
 *      planId: // value for 'planId'
 *      partnerCategoryIds: // value for 'partnerCategoryIds'
 *      imageId: // value for 'imageId'
 *      coverImageId: // value for 'coverImageId'
 *   },
 * });
 */
export function useCreatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePartnerMutation, Types.CreatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePartnerMutation, Types.CreatePartnerMutationVariables>(CreatePartnerDocument, options);
      }
export type CreatePartnerMutationHookResult = ReturnType<typeof useCreatePartnerMutation>;
export type CreatePartnerMutationResult = Apollo.MutationResult<Types.CreatePartnerMutation>;
export type CreatePartnerMutationOptions = Apollo.BaseMutationOptions<Types.CreatePartnerMutation, Types.CreatePartnerMutationVariables>;
export const UpdatePartnerDocument = gql`
    mutation UpdatePartner($id: Int!, $address: String, $email: String, $name: String, $nameAr: String, $phone: String, $planId: Int, $partnerCategoryIds: [Int!], $imageId: Int, $coverImageId: Int) {
  updatePartner(
    id: $id
    updatePartnerDto: {address: $address, email: $email, name: $name, nameAr: $nameAr, phone: $phone, planId: $planId, partnerCategoryIds: $partnerCategoryIds, imageId: $imageId, coverImageId: $coverImageId}
  ) {
    id
  }
}
    `;
export type UpdatePartnerMutationFn = Apollo.MutationFunction<Types.UpdatePartnerMutation, Types.UpdatePartnerMutationVariables>;

/**
 * __useUpdatePartnerMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerMutation, { data, loading, error }] = useUpdatePartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      phone: // value for 'phone'
 *      planId: // value for 'planId'
 *      partnerCategoryIds: // value for 'partnerCategoryIds'
 *      imageId: // value for 'imageId'
 *      coverImageId: // value for 'coverImageId'
 *   },
 * });
 */
export function useUpdatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePartnerMutation, Types.UpdatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePartnerMutation, Types.UpdatePartnerMutationVariables>(UpdatePartnerDocument, options);
      }
export type UpdatePartnerMutationHookResult = ReturnType<typeof useUpdatePartnerMutation>;
export type UpdatePartnerMutationResult = Apollo.MutationResult<Types.UpdatePartnerMutation>;
export type UpdatePartnerMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePartnerMutation, Types.UpdatePartnerMutationVariables>;
export const InvitePartnerUserDocument = gql`
    mutation invitePartnerUser($partnerId: Int!, $email: String!) {
  invitePartnerUser(
    partnerId: $partnerId
    createPartnerInvitationDto: {email: $email}
  )
}
    `;
export type InvitePartnerUserMutationFn = Apollo.MutationFunction<Types.InvitePartnerUserMutation, Types.InvitePartnerUserMutationVariables>;

/**
 * __useInvitePartnerUserMutation__
 *
 * To run a mutation, you first call `useInvitePartnerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitePartnerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitePartnerUserMutation, { data, loading, error }] = useInvitePartnerUserMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInvitePartnerUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.InvitePartnerUserMutation, Types.InvitePartnerUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InvitePartnerUserMutation, Types.InvitePartnerUserMutationVariables>(InvitePartnerUserDocument, options);
      }
export type InvitePartnerUserMutationHookResult = ReturnType<typeof useInvitePartnerUserMutation>;
export type InvitePartnerUserMutationResult = Apollo.MutationResult<Types.InvitePartnerUserMutation>;
export type InvitePartnerUserMutationOptions = Apollo.BaseMutationOptions<Types.InvitePartnerUserMutation, Types.InvitePartnerUserMutationVariables>;
export const GetAllPartnersBalanceDocument = gql`
    query GetAllPartnersBalance($dateFrom: DateTime, $dateTo: DateTime, $partnerId: Int) {
  getAllPartnersBalance(
    filter: {dateFrom: $dateFrom, dateTo: $dateTo, partnerId: $partnerId}
  ) {
    grandTotal
    partners {
      partnerId
      partnerName
      partnerNameAr
      totalBalance
      storeBalances {
        balance
        storeId
        storeName
        storeNameAr
      }
    }
  }
}
    `;

/**
 * __useGetAllPartnersBalanceQuery__
 *
 * To run a query within a React component, call `useGetAllPartnersBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPartnersBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPartnersBalanceQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetAllPartnersBalanceQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllPartnersBalanceQuery, Types.GetAllPartnersBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPartnersBalanceQuery, Types.GetAllPartnersBalanceQueryVariables>(GetAllPartnersBalanceDocument, options);
      }
export function useGetAllPartnersBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPartnersBalanceQuery, Types.GetAllPartnersBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPartnersBalanceQuery, Types.GetAllPartnersBalanceQueryVariables>(GetAllPartnersBalanceDocument, options);
        }
export function useGetAllPartnersBalanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllPartnersBalanceQuery, Types.GetAllPartnersBalanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllPartnersBalanceQuery, Types.GetAllPartnersBalanceQueryVariables>(GetAllPartnersBalanceDocument, options);
        }
export type GetAllPartnersBalanceQueryHookResult = ReturnType<typeof useGetAllPartnersBalanceQuery>;
export type GetAllPartnersBalanceLazyQueryHookResult = ReturnType<typeof useGetAllPartnersBalanceLazyQuery>;
export type GetAllPartnersBalanceSuspenseQueryHookResult = ReturnType<typeof useGetAllPartnersBalanceSuspenseQuery>;
export type GetAllPartnersBalanceQueryResult = Apollo.QueryResult<Types.GetAllPartnersBalanceQuery, Types.GetAllPartnersBalanceQueryVariables>;
export const GetPartnerStoresDocument = gql`
    query GetPartnerStores($partnerId: Int!) {
  getPartnerStores(partnerId: $partnerId) {
    id
    name
    nameAr
    address
    isActive
  }
}
    `;

/**
 * __useGetPartnerStoresQuery__
 *
 * To run a query within a React component, call `useGetPartnerStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerStoresQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetPartnerStoresQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPartnerStoresQuery, Types.GetPartnerStoresQueryVariables> & ({ variables: Types.GetPartnerStoresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPartnerStoresQuery, Types.GetPartnerStoresQueryVariables>(GetPartnerStoresDocument, options);
      }
export function useGetPartnerStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPartnerStoresQuery, Types.GetPartnerStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPartnerStoresQuery, Types.GetPartnerStoresQueryVariables>(GetPartnerStoresDocument, options);
        }
export function useGetPartnerStoresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPartnerStoresQuery, Types.GetPartnerStoresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPartnerStoresQuery, Types.GetPartnerStoresQueryVariables>(GetPartnerStoresDocument, options);
        }
export type GetPartnerStoresQueryHookResult = ReturnType<typeof useGetPartnerStoresQuery>;
export type GetPartnerStoresLazyQueryHookResult = ReturnType<typeof useGetPartnerStoresLazyQuery>;
export type GetPartnerStoresSuspenseQueryHookResult = ReturnType<typeof useGetPartnerStoresSuspenseQuery>;
export type GetPartnerStoresQueryResult = Apollo.QueryResult<Types.GetPartnerStoresQuery, Types.GetPartnerStoresQueryVariables>;
export const GetAllStoresDocument = gql`
    query GetAllStores {
  getAllStores {
    id
    name
    nameAr
    partner {
      id
      name
      nameAr
    }
  }
}
    `;

/**
 * __useGetAllStoresQuery__
 *
 * To run a query within a React component, call `useGetAllStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStoresQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllStoresQuery, Types.GetAllStoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllStoresQuery, Types.GetAllStoresQueryVariables>(GetAllStoresDocument, options);
      }
export function useGetAllStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllStoresQuery, Types.GetAllStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllStoresQuery, Types.GetAllStoresQueryVariables>(GetAllStoresDocument, options);
        }
export function useGetAllStoresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllStoresQuery, Types.GetAllStoresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllStoresQuery, Types.GetAllStoresQueryVariables>(GetAllStoresDocument, options);
        }
export type GetAllStoresQueryHookResult = ReturnType<typeof useGetAllStoresQuery>;
export type GetAllStoresLazyQueryHookResult = ReturnType<typeof useGetAllStoresLazyQuery>;
export type GetAllStoresSuspenseQueryHookResult = ReturnType<typeof useGetAllStoresSuspenseQuery>;
export type GetAllStoresQueryResult = Apollo.QueryResult<Types.GetAllStoresQuery, Types.GetAllStoresQueryVariables>;
export const GetAllPartnerCategoriesDocument = gql`
    query getAllPartnerCategories {
  getAllPartnerCategories {
    id
    name
    nameAr
    media {
      id
      url
      originalName
      fileName
      mimeType
      type
      size
      altText
      description
    }
  }
}
    `;

/**
 * __useGetAllPartnerCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAllPartnerCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPartnerCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPartnerCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPartnerCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>(GetAllPartnerCategoriesDocument, options);
      }
export function useGetAllPartnerCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>(GetAllPartnerCategoriesDocument, options);
        }
export function useGetAllPartnerCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>(GetAllPartnerCategoriesDocument, options);
        }
export type GetAllPartnerCategoriesQueryHookResult = ReturnType<typeof useGetAllPartnerCategoriesQuery>;
export type GetAllPartnerCategoriesLazyQueryHookResult = ReturnType<typeof useGetAllPartnerCategoriesLazyQuery>;
export type GetAllPartnerCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetAllPartnerCategoriesSuspenseQuery>;
export type GetAllPartnerCategoriesQueryResult = Apollo.QueryResult<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>;
export const GetPartnerCategoryDocument = gql`
    query getPartnerCategory($id: Int!) {
  getPartnerCategory(id: $id) {
    id
    name
    nameAr
    media {
      id
      url
      originalName
      fileName
      mimeType
      type
      size
      altText
      description
    }
  }
}
    `;

/**
 * __useGetPartnerCategoryQuery__
 *
 * To run a query within a React component, call `useGetPartnerCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPartnerCategoryQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPartnerCategoryQuery, Types.GetPartnerCategoryQueryVariables> & ({ variables: Types.GetPartnerCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPartnerCategoryQuery, Types.GetPartnerCategoryQueryVariables>(GetPartnerCategoryDocument, options);
      }
export function useGetPartnerCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPartnerCategoryQuery, Types.GetPartnerCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPartnerCategoryQuery, Types.GetPartnerCategoryQueryVariables>(GetPartnerCategoryDocument, options);
        }
export function useGetPartnerCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPartnerCategoryQuery, Types.GetPartnerCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPartnerCategoryQuery, Types.GetPartnerCategoryQueryVariables>(GetPartnerCategoryDocument, options);
        }
export type GetPartnerCategoryQueryHookResult = ReturnType<typeof useGetPartnerCategoryQuery>;
export type GetPartnerCategoryLazyQueryHookResult = ReturnType<typeof useGetPartnerCategoryLazyQuery>;
export type GetPartnerCategorySuspenseQueryHookResult = ReturnType<typeof useGetPartnerCategorySuspenseQuery>;
export type GetPartnerCategoryQueryResult = Apollo.QueryResult<Types.GetPartnerCategoryQuery, Types.GetPartnerCategoryQueryVariables>;
export const CreatePartnerCategoryDocument = gql`
    mutation CreatePartnerCategory($name: String!, $nameAr: String!, $media: CreateMediaDto) {
  createPartnerCategory(
    createPartnerCategoryDto: {name: $name, nameAr: $nameAr, media: $media}
  ) {
    id
    name
    nameAr
  }
}
    `;
export type CreatePartnerCategoryMutationFn = Apollo.MutationFunction<Types.CreatePartnerCategoryMutation, Types.CreatePartnerCategoryMutationVariables>;

/**
 * __useCreatePartnerCategoryMutation__
 *
 * To run a mutation, you first call `useCreatePartnerCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerCategoryMutation, { data, loading, error }] = useCreatePartnerCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      media: // value for 'media'
 *   },
 * });
 */
export function useCreatePartnerCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePartnerCategoryMutation, Types.CreatePartnerCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePartnerCategoryMutation, Types.CreatePartnerCategoryMutationVariables>(CreatePartnerCategoryDocument, options);
      }
export type CreatePartnerCategoryMutationHookResult = ReturnType<typeof useCreatePartnerCategoryMutation>;
export type CreatePartnerCategoryMutationResult = Apollo.MutationResult<Types.CreatePartnerCategoryMutation>;
export type CreatePartnerCategoryMutationOptions = Apollo.BaseMutationOptions<Types.CreatePartnerCategoryMutation, Types.CreatePartnerCategoryMutationVariables>;
export const UpdatePartnerCategoryDocument = gql`
    mutation UpdatePartnerCategory($id: Int!, $name: String, $nameAr: String, $media: CreateMediaDto) {
  updatePartnerCategory(
    id: $id
    updatePartnerCategoryDto: {name: $name, nameAr: $nameAr, media: $media}
  ) {
    id
    name
    nameAr
  }
}
    `;
export type UpdatePartnerCategoryMutationFn = Apollo.MutationFunction<Types.UpdatePartnerCategoryMutation, Types.UpdatePartnerCategoryMutationVariables>;

/**
 * __useUpdatePartnerCategoryMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerCategoryMutation, { data, loading, error }] = useUpdatePartnerCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      media: // value for 'media'
 *   },
 * });
 */
export function useUpdatePartnerCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePartnerCategoryMutation, Types.UpdatePartnerCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePartnerCategoryMutation, Types.UpdatePartnerCategoryMutationVariables>(UpdatePartnerCategoryDocument, options);
      }
export type UpdatePartnerCategoryMutationHookResult = ReturnType<typeof useUpdatePartnerCategoryMutation>;
export type UpdatePartnerCategoryMutationResult = Apollo.MutationResult<Types.UpdatePartnerCategoryMutation>;
export type UpdatePartnerCategoryMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePartnerCategoryMutation, Types.UpdatePartnerCategoryMutationVariables>;
export const DeletePartnerCategoryDocument = gql`
    mutation DeletePartnerCategory($id: Int!) {
  deletePartnerCategory(id: $id)
}
    `;
export type DeletePartnerCategoryMutationFn = Apollo.MutationFunction<Types.DeletePartnerCategoryMutation, Types.DeletePartnerCategoryMutationVariables>;

/**
 * __useDeletePartnerCategoryMutation__
 *
 * To run a mutation, you first call `useDeletePartnerCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartnerCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartnerCategoryMutation, { data, loading, error }] = useDeletePartnerCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePartnerCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePartnerCategoryMutation, Types.DeletePartnerCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePartnerCategoryMutation, Types.DeletePartnerCategoryMutationVariables>(DeletePartnerCategoryDocument, options);
      }
export type DeletePartnerCategoryMutationHookResult = ReturnType<typeof useDeletePartnerCategoryMutation>;
export type DeletePartnerCategoryMutationResult = Apollo.MutationResult<Types.DeletePartnerCategoryMutation>;
export type DeletePartnerCategoryMutationOptions = Apollo.BaseMutationOptions<Types.DeletePartnerCategoryMutation, Types.DeletePartnerCategoryMutationVariables>;
export const GetPartnerPromoTrackingDocument = gql`
    query GetPartnerPromoTracking($partnerId: Int!) {
  getPartnerPromoTracking(partnerId: $partnerId) {
    partner {
      id
      name
    }
    promoCodes {
      id
      code
      description
      discountType
      discountValue
      minCartAmount
      maxDiscountAmount
      usageLimit
      usageCount
      perUserLimit
      startsAt
      endsAt
      isActive
      storeId
    }
  }
}
    `;

/**
 * __useGetPartnerPromoTrackingQuery__
 *
 * To run a query within a React component, call `useGetPartnerPromoTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerPromoTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerPromoTrackingQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useGetPartnerPromoTrackingQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPartnerPromoTrackingQuery, Types.GetPartnerPromoTrackingQueryVariables> & ({ variables: Types.GetPartnerPromoTrackingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPartnerPromoTrackingQuery, Types.GetPartnerPromoTrackingQueryVariables>(GetPartnerPromoTrackingDocument, options);
      }
export function useGetPartnerPromoTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPartnerPromoTrackingQuery, Types.GetPartnerPromoTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPartnerPromoTrackingQuery, Types.GetPartnerPromoTrackingQueryVariables>(GetPartnerPromoTrackingDocument, options);
        }
export function useGetPartnerPromoTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPartnerPromoTrackingQuery, Types.GetPartnerPromoTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPartnerPromoTrackingQuery, Types.GetPartnerPromoTrackingQueryVariables>(GetPartnerPromoTrackingDocument, options);
        }
export type GetPartnerPromoTrackingQueryHookResult = ReturnType<typeof useGetPartnerPromoTrackingQuery>;
export type GetPartnerPromoTrackingLazyQueryHookResult = ReturnType<typeof useGetPartnerPromoTrackingLazyQuery>;
export type GetPartnerPromoTrackingSuspenseQueryHookResult = ReturnType<typeof useGetPartnerPromoTrackingSuspenseQuery>;
export type GetPartnerPromoTrackingQueryResult = Apollo.QueryResult<Types.GetPartnerPromoTrackingQuery, Types.GetPartnerPromoTrackingQueryVariables>;
export const GetPartnerStatisticsDocument = gql`
    query GetPartnerStatistics($input: GetPartnerStatisticsInput!) {
  getPartnerStatistics(input: $input) {
    averageEarningsPerDelivery
    cancelledDeliveries
    completedDeliveries
    completionRate
    totalDeliveries
    totalDeliveryFees
    totalEarnings
    totalTips
    dailyTrend {
      date
      deliveryCount
      totalEarnings
    }
    topPartners {
      averageEarningsPerDelivery
      cancelledDeliveries
      completedDeliveries
      completionRate
      partnerId
      partnerName
      totalDeliveries
      totalDeliveryFees
      totalEarnings
      totalTips
    }
    topStoresByPartner {
      averageOrderValue
      orderCount
      storeId
      storeName
      storeNameAr
      totalRevenue
    }
  }
}
    `;

/**
 * __useGetPartnerStatisticsQuery__
 *
 * To run a query within a React component, call `useGetPartnerStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerStatisticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPartnerStatisticsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPartnerStatisticsQuery, Types.GetPartnerStatisticsQueryVariables> & ({ variables: Types.GetPartnerStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPartnerStatisticsQuery, Types.GetPartnerStatisticsQueryVariables>(GetPartnerStatisticsDocument, options);
      }
export function useGetPartnerStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPartnerStatisticsQuery, Types.GetPartnerStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPartnerStatisticsQuery, Types.GetPartnerStatisticsQueryVariables>(GetPartnerStatisticsDocument, options);
        }
export function useGetPartnerStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPartnerStatisticsQuery, Types.GetPartnerStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPartnerStatisticsQuery, Types.GetPartnerStatisticsQueryVariables>(GetPartnerStatisticsDocument, options);
        }
export type GetPartnerStatisticsQueryHookResult = ReturnType<typeof useGetPartnerStatisticsQuery>;
export type GetPartnerStatisticsLazyQueryHookResult = ReturnType<typeof useGetPartnerStatisticsLazyQuery>;
export type GetPartnerStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetPartnerStatisticsSuspenseQuery>;
export type GetPartnerStatisticsQueryResult = Apollo.QueryResult<Types.GetPartnerStatisticsQuery, Types.GetPartnerStatisticsQueryVariables>;
export const GetAllPermissionsDocument = gql`
    query GetAllPermissions {
  getAllPermissions {
    createdAt
    functions
    id
    name
    role
    updatedAt
  }
}
    `;

/**
 * __useGetAllPermissionsQuery__
 *
 * To run a query within a React component, call `useGetAllPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllPermissionsQuery, Types.GetAllPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPermissionsQuery, Types.GetAllPermissionsQueryVariables>(GetAllPermissionsDocument, options);
      }
export function useGetAllPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPermissionsQuery, Types.GetAllPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPermissionsQuery, Types.GetAllPermissionsQueryVariables>(GetAllPermissionsDocument, options);
        }
export function useGetAllPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllPermissionsQuery, Types.GetAllPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllPermissionsQuery, Types.GetAllPermissionsQueryVariables>(GetAllPermissionsDocument, options);
        }
export type GetAllPermissionsQueryHookResult = ReturnType<typeof useGetAllPermissionsQuery>;
export type GetAllPermissionsLazyQueryHookResult = ReturnType<typeof useGetAllPermissionsLazyQuery>;
export type GetAllPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetAllPermissionsSuspenseQuery>;
export type GetAllPermissionsQueryResult = Apollo.QueryResult<Types.GetAllPermissionsQuery, Types.GetAllPermissionsQueryVariables>;
export const GetPermissionDocument = gql`
    query GetPermission($id: Int!) {
  getPermission(id: $id) {
    createdAt
    functions
    id
    name
    role
    updatedAt
  }
}
    `;

/**
 * __useGetPermissionQuery__
 *
 * To run a query within a React component, call `useGetPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPermissionQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPermissionQuery, Types.GetPermissionQueryVariables> & ({ variables: Types.GetPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPermissionQuery, Types.GetPermissionQueryVariables>(GetPermissionDocument, options);
      }
export function useGetPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPermissionQuery, Types.GetPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPermissionQuery, Types.GetPermissionQueryVariables>(GetPermissionDocument, options);
        }
export function useGetPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPermissionQuery, Types.GetPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPermissionQuery, Types.GetPermissionQueryVariables>(GetPermissionDocument, options);
        }
export type GetPermissionQueryHookResult = ReturnType<typeof useGetPermissionQuery>;
export type GetPermissionLazyQueryHookResult = ReturnType<typeof useGetPermissionLazyQuery>;
export type GetPermissionSuspenseQueryHookResult = ReturnType<typeof useGetPermissionSuspenseQuery>;
export type GetPermissionQueryResult = Apollo.QueryResult<Types.GetPermissionQuery, Types.GetPermissionQueryVariables>;
export const GetRoleFucntionsDocument = gql`
    query GetRoleFucntions {
  getRoleFucntions {
    functions
    role
  }
}
    `;

/**
 * __useGetRoleFucntionsQuery__
 *
 * To run a query within a React component, call `useGetRoleFucntionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleFucntionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleFucntionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoleFucntionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetRoleFucntionsQuery, Types.GetRoleFucntionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRoleFucntionsQuery, Types.GetRoleFucntionsQueryVariables>(GetRoleFucntionsDocument, options);
      }
export function useGetRoleFucntionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRoleFucntionsQuery, Types.GetRoleFucntionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRoleFucntionsQuery, Types.GetRoleFucntionsQueryVariables>(GetRoleFucntionsDocument, options);
        }
export function useGetRoleFucntionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetRoleFucntionsQuery, Types.GetRoleFucntionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRoleFucntionsQuery, Types.GetRoleFucntionsQueryVariables>(GetRoleFucntionsDocument, options);
        }
export type GetRoleFucntionsQueryHookResult = ReturnType<typeof useGetRoleFucntionsQuery>;
export type GetRoleFucntionsLazyQueryHookResult = ReturnType<typeof useGetRoleFucntionsLazyQuery>;
export type GetRoleFucntionsSuspenseQueryHookResult = ReturnType<typeof useGetRoleFucntionsSuspenseQuery>;
export type GetRoleFucntionsQueryResult = Apollo.QueryResult<Types.GetRoleFucntionsQuery, Types.GetRoleFucntionsQueryVariables>;
export const CreatePermissionDocument = gql`
    mutation CreatePermission($name: String!, $role: String!, $functions: [String!]!) {
  createPermission(
    createPermissionDto: {name: $name, role: $role, functions: $functions}
  ) {
    id
  }
}
    `;
export type CreatePermissionMutationFn = Apollo.MutationFunction<Types.CreatePermissionMutation, Types.CreatePermissionMutationVariables>;

/**
 * __useCreatePermissionMutation__
 *
 * To run a mutation, you first call `useCreatePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionMutation, { data, loading, error }] = useCreatePermissionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      role: // value for 'role'
 *      functions: // value for 'functions'
 *   },
 * });
 */
export function useCreatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePermissionMutation, Types.CreatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePermissionMutation, Types.CreatePermissionMutationVariables>(CreatePermissionDocument, options);
      }
export type CreatePermissionMutationHookResult = ReturnType<typeof useCreatePermissionMutation>;
export type CreatePermissionMutationResult = Apollo.MutationResult<Types.CreatePermissionMutation>;
export type CreatePermissionMutationOptions = Apollo.BaseMutationOptions<Types.CreatePermissionMutation, Types.CreatePermissionMutationVariables>;
export const UpdatePermissionDocument = gql`
    mutation UpdatePermission($id: Int!, $name: String!, $role: String!, $functions: [String!]!) {
  updatePermission(
    id: $id
    updatePermissionDto: {name: $name, role: $role, functions: $functions}
  ) {
    id
  }
}
    `;
export type UpdatePermissionMutationFn = Apollo.MutationFunction<Types.UpdatePermissionMutation, Types.UpdatePermissionMutationVariables>;

/**
 * __useUpdatePermissionMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionMutation, { data, loading, error }] = useUpdatePermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      role: // value for 'role'
 *      functions: // value for 'functions'
 *   },
 * });
 */
export function useUpdatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePermissionMutation, Types.UpdatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePermissionMutation, Types.UpdatePermissionMutationVariables>(UpdatePermissionDocument, options);
      }
export type UpdatePermissionMutationHookResult = ReturnType<typeof useUpdatePermissionMutation>;
export type UpdatePermissionMutationResult = Apollo.MutationResult<Types.UpdatePermissionMutation>;
export type UpdatePermissionMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePermissionMutation, Types.UpdatePermissionMutationVariables>;
export const DeletePermissionDocument = gql`
    mutation DeletePermission($id: Int!) {
  deletePermission(id: $id)
}
    `;
export type DeletePermissionMutationFn = Apollo.MutationFunction<Types.DeletePermissionMutation, Types.DeletePermissionMutationVariables>;

/**
 * __useDeletePermissionMutation__
 *
 * To run a mutation, you first call `useDeletePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePermissionMutation, { data, loading, error }] = useDeletePermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePermissionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePermissionMutation, Types.DeletePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePermissionMutation, Types.DeletePermissionMutationVariables>(DeletePermissionDocument, options);
      }
export type DeletePermissionMutationHookResult = ReturnType<typeof useDeletePermissionMutation>;
export type DeletePermissionMutationResult = Apollo.MutationResult<Types.DeletePermissionMutation>;
export type DeletePermissionMutationOptions = Apollo.BaseMutationOptions<Types.DeletePermissionMutation, Types.DeletePermissionMutationVariables>;
export const GetAllPlansDocument = gql`
    query GetAllPlans {
  getAllPlans {
    id
    name
  }
}
    `;

/**
 * __useGetAllPlansQuery__
 *
 * To run a query within a React component, call `useGetAllPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPlansQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllPlansQuery, Types.GetAllPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPlansQuery, Types.GetAllPlansQueryVariables>(GetAllPlansDocument, options);
      }
export function useGetAllPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPlansQuery, Types.GetAllPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPlansQuery, Types.GetAllPlansQueryVariables>(GetAllPlansDocument, options);
        }
export function useGetAllPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllPlansQuery, Types.GetAllPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllPlansQuery, Types.GetAllPlansQueryVariables>(GetAllPlansDocument, options);
        }
export type GetAllPlansQueryHookResult = ReturnType<typeof useGetAllPlansQuery>;
export type GetAllPlansLazyQueryHookResult = ReturnType<typeof useGetAllPlansLazyQuery>;
export type GetAllPlansSuspenseQueryHookResult = ReturnType<typeof useGetAllPlansSuspenseQuery>;
export type GetAllPlansQueryResult = Apollo.QueryResult<Types.GetAllPlansQuery, Types.GetAllPlansQueryVariables>;
export const GetPlanDocument = gql`
    query GetPlan($id: Int!) {
  getPlan(id: $id) {
    id
    name
    commissionRate
    minCommissionAmount
    individualOrderDiscounts {
      discountRate
      id
      minimumCartAmount
      partnerCoverageType
      partnerCoverageRate
      maxDiscountAmount
    }
    scheduledIndividualOrderDiscounts {
      discountRate
      id
      minimumCartAmount
      partnerCoverageType
      partnerCoverageRate
      maxDiscountAmount
    }
    urgentIndividualOrderDiscounts {
      discountRate
      id
      minimumCartAmount
      partnerCoverageType
      partnerCoverageRate
      maxDiscountAmount
    }
    groupOrderDiscounts {
      discountRate
      id
      minimumCartAmount
      numberOfMembers
      partnerCoverageType
      partnerCoverageRate
      maxDiscountAmount
    }
    groupDeliveryDiscounts {
      discountRate
      id
      minimumCartAmount
      numberOfMembers
      partnerCoverageType
      partnerCoverageRate
      maxDiscountAmount
    }
    flashSaleDiscounts {
      discountRate
      id
      minimumCartAmount
      numberOfMembers
      partnerCoverageType
      partnerCoverageRate
      maxDiscountAmount
    }
    deliveryPlan {
      defaultDeliveryFee
      id
      items {
        afterDiscountDeliveryFee
        id
        minimumCartAmount
        partnerCoverageAmount
        scheduledType
      }
    }
  }
}
    `;

/**
 * __useGetPlanQuery__
 *
 * To run a query within a React component, call `useGetPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlanQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPlanQuery, Types.GetPlanQueryVariables> & ({ variables: Types.GetPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPlanQuery, Types.GetPlanQueryVariables>(GetPlanDocument, options);
      }
export function useGetPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPlanQuery, Types.GetPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPlanQuery, Types.GetPlanQueryVariables>(GetPlanDocument, options);
        }
export function useGetPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPlanQuery, Types.GetPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPlanQuery, Types.GetPlanQueryVariables>(GetPlanDocument, options);
        }
export type GetPlanQueryHookResult = ReturnType<typeof useGetPlanQuery>;
export type GetPlanLazyQueryHookResult = ReturnType<typeof useGetPlanLazyQuery>;
export type GetPlanSuspenseQueryHookResult = ReturnType<typeof useGetPlanSuspenseQuery>;
export type GetPlanQueryResult = Apollo.QueryResult<Types.GetPlanQuery, Types.GetPlanQueryVariables>;
export const CreatePlanDocument = gql`
    mutation CreatePlan($name: String!, $commissionRate: Int!, $minCommissionAmount: Int!, $deliveryPlan: DeliveryPlanDto!, $individualOrderDiscounts: [IndividualOrderDiscountDto!]!, $scheduledIndividualOrderDiscounts: [ScheduledIndividualOrderDiscountDto!]!, $urgentIndividualOrderDiscounts: [UrgentIndividualOrderDiscountDto!]!, $groupDeliveryDiscounts: [GroupDeliveryDiscountDto!]!, $groupOrderDiscounts: [GroupOrderDiscountDto!]!, $flashSaleDiscounts: [FlashSaleDiscountDto!]!) {
  createPlan(
    createPlanDto: {name: $name, commissionRate: $commissionRate, minCommissionAmount: $minCommissionAmount, deliveryPlan: $deliveryPlan, individualOrderDiscounts: $individualOrderDiscounts, scheduledIndividualOrderDiscounts: $scheduledIndividualOrderDiscounts, urgentIndividualOrderDiscounts: $urgentIndividualOrderDiscounts, groupDeliveryDiscounts: $groupDeliveryDiscounts, groupOrderDiscounts: $groupOrderDiscounts, flashSaleDiscounts: $flashSaleDiscounts}
  ) {
    id
  }
}
    `;
export type CreatePlanMutationFn = Apollo.MutationFunction<Types.CreatePlanMutation, Types.CreatePlanMutationVariables>;

/**
 * __useCreatePlanMutation__
 *
 * To run a mutation, you first call `useCreatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlanMutation, { data, loading, error }] = useCreatePlanMutation({
 *   variables: {
 *      name: // value for 'name'
 *      commissionRate: // value for 'commissionRate'
 *      minCommissionAmount: // value for 'minCommissionAmount'
 *      deliveryPlan: // value for 'deliveryPlan'
 *      individualOrderDiscounts: // value for 'individualOrderDiscounts'
 *      scheduledIndividualOrderDiscounts: // value for 'scheduledIndividualOrderDiscounts'
 *      urgentIndividualOrderDiscounts: // value for 'urgentIndividualOrderDiscounts'
 *      groupDeliveryDiscounts: // value for 'groupDeliveryDiscounts'
 *      groupOrderDiscounts: // value for 'groupOrderDiscounts'
 *      flashSaleDiscounts: // value for 'flashSaleDiscounts'
 *   },
 * });
 */
export function useCreatePlanMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePlanMutation, Types.CreatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePlanMutation, Types.CreatePlanMutationVariables>(CreatePlanDocument, options);
      }
export type CreatePlanMutationHookResult = ReturnType<typeof useCreatePlanMutation>;
export type CreatePlanMutationResult = Apollo.MutationResult<Types.CreatePlanMutation>;
export type CreatePlanMutationOptions = Apollo.BaseMutationOptions<Types.CreatePlanMutation, Types.CreatePlanMutationVariables>;
export const UpdatePlanDocument = gql`
    mutation UpdatePlan($id: Int!, $name: String, $commissionRate: Int!, $minCommissionAmount: Int!, $deliveryPlan: DeliveryPlanDto, $individualOrderDiscounts: [IndividualOrderDiscountDto!], $scheduledIndividualOrderDiscounts: [ScheduledIndividualOrderDiscountDto!], $urgentIndividualOrderDiscounts: [UrgentIndividualOrderDiscountDto!], $groupDeliveryDiscounts: [GroupDeliveryDiscountDto!], $groupOrderDiscounts: [GroupOrderDiscountDto!], $flashSaleDiscounts: [FlashSaleDiscountDto!]) {
  updatePlan(
    id: $id
    updatePlanDto: {name: $name, commissionRate: $commissionRate, minCommissionAmount: $minCommissionAmount, deliveryPlan: $deliveryPlan, individualOrderDiscounts: $individualOrderDiscounts, scheduledIndividualOrderDiscounts: $scheduledIndividualOrderDiscounts, urgentIndividualOrderDiscounts: $urgentIndividualOrderDiscounts, groupDeliveryDiscounts: $groupDeliveryDiscounts, groupOrderDiscounts: $groupOrderDiscounts, flashSaleDiscounts: $flashSaleDiscounts}
  ) {
    id
  }
}
    `;
export type UpdatePlanMutationFn = Apollo.MutationFunction<Types.UpdatePlanMutation, Types.UpdatePlanMutationVariables>;

/**
 * __useUpdatePlanMutation__
 *
 * To run a mutation, you first call `useUpdatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanMutation, { data, loading, error }] = useUpdatePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      commissionRate: // value for 'commissionRate'
 *      minCommissionAmount: // value for 'minCommissionAmount'
 *      deliveryPlan: // value for 'deliveryPlan'
 *      individualOrderDiscounts: // value for 'individualOrderDiscounts'
 *      scheduledIndividualOrderDiscounts: // value for 'scheduledIndividualOrderDiscounts'
 *      urgentIndividualOrderDiscounts: // value for 'urgentIndividualOrderDiscounts'
 *      groupDeliveryDiscounts: // value for 'groupDeliveryDiscounts'
 *      groupOrderDiscounts: // value for 'groupOrderDiscounts'
 *      flashSaleDiscounts: // value for 'flashSaleDiscounts'
 *   },
 * });
 */
export function useUpdatePlanMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePlanMutation, Types.UpdatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePlanMutation, Types.UpdatePlanMutationVariables>(UpdatePlanDocument, options);
      }
export type UpdatePlanMutationHookResult = ReturnType<typeof useUpdatePlanMutation>;
export type UpdatePlanMutationResult = Apollo.MutationResult<Types.UpdatePlanMutation>;
export type UpdatePlanMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePlanMutation, Types.UpdatePlanMutationVariables>;
export const DeletePlanDocument = gql`
    mutation DeletePlan($id: Int!) {
  deletePlan(id: $id)
}
    `;
export type DeletePlanMutationFn = Apollo.MutationFunction<Types.DeletePlanMutation, Types.DeletePlanMutationVariables>;

/**
 * __useDeletePlanMutation__
 *
 * To run a mutation, you first call `useDeletePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanMutation, { data, loading, error }] = useDeletePlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlanMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePlanMutation, Types.DeletePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePlanMutation, Types.DeletePlanMutationVariables>(DeletePlanDocument, options);
      }
export type DeletePlanMutationHookResult = ReturnType<typeof useDeletePlanMutation>;
export type DeletePlanMutationResult = Apollo.MutationResult<Types.DeletePlanMutation>;
export type DeletePlanMutationOptions = Apollo.BaseMutationOptions<Types.DeletePlanMutation, Types.DeletePlanMutationVariables>;
export const GetAllPromoCodesDocument = gql`
    query GetAllPromoCodes {
  getAllPromoCodes {
    id
    code
    description
    discountType
    discountValue
    minCartAmount
    maxDiscountAmount
    usageLimit
    usageCount
    perUserLimit
    startsAt
    endsAt
    isActive
    storeId
    store {
      id
      name
      nameAr
      partner {
        id
        name
        nameAr
      }
    }
  }
}
    `;

/**
 * __useGetAllPromoCodesQuery__
 *
 * To run a query within a React component, call `useGetAllPromoCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPromoCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPromoCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPromoCodesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllPromoCodesQuery, Types.GetAllPromoCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPromoCodesQuery, Types.GetAllPromoCodesQueryVariables>(GetAllPromoCodesDocument, options);
      }
export function useGetAllPromoCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPromoCodesQuery, Types.GetAllPromoCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPromoCodesQuery, Types.GetAllPromoCodesQueryVariables>(GetAllPromoCodesDocument, options);
        }
export function useGetAllPromoCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetAllPromoCodesQuery, Types.GetAllPromoCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllPromoCodesQuery, Types.GetAllPromoCodesQueryVariables>(GetAllPromoCodesDocument, options);
        }
export type GetAllPromoCodesQueryHookResult = ReturnType<typeof useGetAllPromoCodesQuery>;
export type GetAllPromoCodesLazyQueryHookResult = ReturnType<typeof useGetAllPromoCodesLazyQuery>;
export type GetAllPromoCodesSuspenseQueryHookResult = ReturnType<typeof useGetAllPromoCodesSuspenseQuery>;
export type GetAllPromoCodesQueryResult = Apollo.QueryResult<Types.GetAllPromoCodesQuery, Types.GetAllPromoCodesQueryVariables>;
export const GetPromoCodeDocument = gql`
    query GetPromoCode($id: Int!) {
  getPromoCode(id: $id) {
    id
    code
    description
    discountType
    discountValue
    minCartAmount
    maxDiscountAmount
    usageLimit
    usageCount
    perUserLimit
    startsAt
    endsAt
    isActive
    storeId
  }
}
    `;

/**
 * __useGetPromoCodeQuery__
 *
 * To run a query within a React component, call `useGetPromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromoCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPromoCodeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables> & ({ variables: Types.GetPromoCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>(GetPromoCodeDocument, options);
      }
export function useGetPromoCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>(GetPromoCodeDocument, options);
        }
export function useGetPromoCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>(GetPromoCodeDocument, options);
        }
export type GetPromoCodeQueryHookResult = ReturnType<typeof useGetPromoCodeQuery>;
export type GetPromoCodeLazyQueryHookResult = ReturnType<typeof useGetPromoCodeLazyQuery>;
export type GetPromoCodeSuspenseQueryHookResult = ReturnType<typeof useGetPromoCodeSuspenseQuery>;
export type GetPromoCodeQueryResult = Apollo.QueryResult<Types.GetPromoCodeQuery, Types.GetPromoCodeQueryVariables>;
export const CreatePromoCodeDocument = gql`
    mutation CreatePromoCode($createPromoCodeDto: CreatePromoCodeDto!) {
  createPromoCode(createPromoCodeDto: $createPromoCodeDto) {
    id
  }
}
    `;
export type CreatePromoCodeMutationFn = Apollo.MutationFunction<Types.CreatePromoCodeMutation, Types.CreatePromoCodeMutationVariables>;

/**
 * __useCreatePromoCodeMutation__
 *
 * To run a mutation, you first call `useCreatePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPromoCodeMutation, { data, loading, error }] = useCreatePromoCodeMutation({
 *   variables: {
 *      createPromoCodeDto: // value for 'createPromoCodeDto'
 *   },
 * });
 */
export function useCreatePromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePromoCodeMutation, Types.CreatePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePromoCodeMutation, Types.CreatePromoCodeMutationVariables>(CreatePromoCodeDocument, options);
      }
export type CreatePromoCodeMutationHookResult = ReturnType<typeof useCreatePromoCodeMutation>;
export type CreatePromoCodeMutationResult = Apollo.MutationResult<Types.CreatePromoCodeMutation>;
export type CreatePromoCodeMutationOptions = Apollo.BaseMutationOptions<Types.CreatePromoCodeMutation, Types.CreatePromoCodeMutationVariables>;
export const UpdatePromoCodeDocument = gql`
    mutation UpdatePromoCode($id: Int!, $updatePromoCodeDto: UpdatePromoCodeDto!) {
  updatePromoCode(id: $id, updatePromoCodeDto: $updatePromoCodeDto) {
    id
  }
}
    `;
export type UpdatePromoCodeMutationFn = Apollo.MutationFunction<Types.UpdatePromoCodeMutation, Types.UpdatePromoCodeMutationVariables>;

/**
 * __useUpdatePromoCodeMutation__
 *
 * To run a mutation, you first call `useUpdatePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePromoCodeMutation, { data, loading, error }] = useUpdatePromoCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatePromoCodeDto: // value for 'updatePromoCodeDto'
 *   },
 * });
 */
export function useUpdatePromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePromoCodeMutation, Types.UpdatePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePromoCodeMutation, Types.UpdatePromoCodeMutationVariables>(UpdatePromoCodeDocument, options);
      }
export type UpdatePromoCodeMutationHookResult = ReturnType<typeof useUpdatePromoCodeMutation>;
export type UpdatePromoCodeMutationResult = Apollo.MutationResult<Types.UpdatePromoCodeMutation>;
export type UpdatePromoCodeMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePromoCodeMutation, Types.UpdatePromoCodeMutationVariables>;
export const DeletePromoCodeDocument = gql`
    mutation DeletePromoCode($id: Int!) {
  deletePromoCode(id: $id)
}
    `;
export type DeletePromoCodeMutationFn = Apollo.MutationFunction<Types.DeletePromoCodeMutation, Types.DeletePromoCodeMutationVariables>;

/**
 * __useDeletePromoCodeMutation__
 *
 * To run a mutation, you first call `useDeletePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePromoCodeMutation, { data, loading, error }] = useDeletePromoCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePromoCodeMutation, Types.DeletePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePromoCodeMutation, Types.DeletePromoCodeMutationVariables>(DeletePromoCodeDocument, options);
      }
export type DeletePromoCodeMutationHookResult = ReturnType<typeof useDeletePromoCodeMutation>;
export type DeletePromoCodeMutationResult = Apollo.MutationResult<Types.DeletePromoCodeMutation>;
export type DeletePromoCodeMutationOptions = Apollo.BaseMutationOptions<Types.DeletePromoCodeMutation, Types.DeletePromoCodeMutationVariables>;
export const GetGoogleMapsRushHoursDocument = gql`
    query GetGoogleMapsRushHours {
  getGoogleMapsRushHours {
    id
    rules {
      date
      timeFrom
      timeTo
      marginMinutes
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetGoogleMapsRushHoursQuery__
 *
 * To run a query within a React component, call `useGetGoogleMapsRushHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleMapsRushHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleMapsRushHoursQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoogleMapsRushHoursQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetGoogleMapsRushHoursQuery, Types.GetGoogleMapsRushHoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGoogleMapsRushHoursQuery, Types.GetGoogleMapsRushHoursQueryVariables>(GetGoogleMapsRushHoursDocument, options);
      }
export function useGetGoogleMapsRushHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGoogleMapsRushHoursQuery, Types.GetGoogleMapsRushHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGoogleMapsRushHoursQuery, Types.GetGoogleMapsRushHoursQueryVariables>(GetGoogleMapsRushHoursDocument, options);
        }
export function useGetGoogleMapsRushHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetGoogleMapsRushHoursQuery, Types.GetGoogleMapsRushHoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetGoogleMapsRushHoursQuery, Types.GetGoogleMapsRushHoursQueryVariables>(GetGoogleMapsRushHoursDocument, options);
        }
export type GetGoogleMapsRushHoursQueryHookResult = ReturnType<typeof useGetGoogleMapsRushHoursQuery>;
export type GetGoogleMapsRushHoursLazyQueryHookResult = ReturnType<typeof useGetGoogleMapsRushHoursLazyQuery>;
export type GetGoogleMapsRushHoursSuspenseQueryHookResult = ReturnType<typeof useGetGoogleMapsRushHoursSuspenseQuery>;
export type GetGoogleMapsRushHoursQueryResult = Apollo.QueryResult<Types.GetGoogleMapsRushHoursQuery, Types.GetGoogleMapsRushHoursQueryVariables>;
export const SaveGoogleMapsRushHoursDocument = gql`
    mutation SaveGoogleMapsRushHours($saveGoogleMapsRushHoursDto: SaveGoogleMapsRushHoursDto!) {
  saveGoogleMapsRushHours(saveGoogleMapsRushHoursDto: $saveGoogleMapsRushHoursDto) {
    id
    rules {
      date
      timeFrom
      timeTo
      marginMinutes
    }
  }
}
    `;
export type SaveGoogleMapsRushHoursMutationFn = Apollo.MutationFunction<Types.SaveGoogleMapsRushHoursMutation, Types.SaveGoogleMapsRushHoursMutationVariables>;

/**
 * __useSaveGoogleMapsRushHoursMutation__
 *
 * To run a mutation, you first call `useSaveGoogleMapsRushHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGoogleMapsRushHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGoogleMapsRushHoursMutation, { data, loading, error }] = useSaveGoogleMapsRushHoursMutation({
 *   variables: {
 *      saveGoogleMapsRushHoursDto: // value for 'saveGoogleMapsRushHoursDto'
 *   },
 * });
 */
export function useSaveGoogleMapsRushHoursMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveGoogleMapsRushHoursMutation, Types.SaveGoogleMapsRushHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveGoogleMapsRushHoursMutation, Types.SaveGoogleMapsRushHoursMutationVariables>(SaveGoogleMapsRushHoursDocument, options);
      }
export type SaveGoogleMapsRushHoursMutationHookResult = ReturnType<typeof useSaveGoogleMapsRushHoursMutation>;
export type SaveGoogleMapsRushHoursMutationResult = Apollo.MutationResult<Types.SaveGoogleMapsRushHoursMutation>;
export type SaveGoogleMapsRushHoursMutationOptions = Apollo.BaseMutationOptions<Types.SaveGoogleMapsRushHoursMutation, Types.SaveGoogleMapsRushHoursMutationVariables>;
export const AddLedgerTransactionDocument = gql`
    mutation AddLedgerTransaction($amountMinor: String!, $description: String, $orderId: Int, $status: TransactionStatus!, $storeId: Int!, $type: TransactionType!, $media: CreateMediaDto) {
  addLedgerTransaction(
    input: {amountMinor: $amountMinor, description: $description, media: $media, orderId: $orderId, status: $status, storeId: $storeId, type: $type}
  ) {
    amountMinor
    availableAt
    correlationId
    createdAt
    description
    id
    idempotencyKey
    meta
    postedAt
    status
    type
    updatedAt
  }
}
    `;
export type AddLedgerTransactionMutationFn = Apollo.MutationFunction<Types.AddLedgerTransactionMutation, Types.AddLedgerTransactionMutationVariables>;

/**
 * __useAddLedgerTransactionMutation__
 *
 * To run a mutation, you first call `useAddLedgerTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLedgerTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLedgerTransactionMutation, { data, loading, error }] = useAddLedgerTransactionMutation({
 *   variables: {
 *      amountMinor: // value for 'amountMinor'
 *      description: // value for 'description'
 *      orderId: // value for 'orderId'
 *      status: // value for 'status'
 *      storeId: // value for 'storeId'
 *      type: // value for 'type'
 *      media: // value for 'media'
 *   },
 * });
 */
export function useAddLedgerTransactionMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddLedgerTransactionMutation, Types.AddLedgerTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddLedgerTransactionMutation, Types.AddLedgerTransactionMutationVariables>(AddLedgerTransactionDocument, options);
      }
export type AddLedgerTransactionMutationHookResult = ReturnType<typeof useAddLedgerTransactionMutation>;
export type AddLedgerTransactionMutationResult = Apollo.MutationResult<Types.AddLedgerTransactionMutation>;
export type AddLedgerTransactionMutationOptions = Apollo.BaseMutationOptions<Types.AddLedgerTransactionMutation, Types.AddLedgerTransactionMutationVariables>;
export const LedgerTransactionsDocument = gql`
    query LedgerTransactions($pagination: PaginationInput!, $filter: LedgerTransactionsFilter, $sort: SortInput) {
  ledgerTransactions(pagination: $pagination, filter: $filter, sort: $sort) {
    hasMore
    total
    items {
      amountMinor
      availableAt
      correlationId
      createdAt
      description
      id
      idempotencyKey
      orderId
      postedAt
      status
      storeId
      type
      partner {
        ar
        en
      }
      store {
        ar
        en
      }
    }
  }
}
    `;

/**
 * __useLedgerTransactionsQuery__
 *
 * To run a query within a React component, call `useLedgerTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerTransactionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLedgerTransactionsQuery(baseOptions: Apollo.QueryHookOptions<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables> & ({ variables: Types.LedgerTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>(LedgerTransactionsDocument, options);
      }
export function useLedgerTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>(LedgerTransactionsDocument, options);
        }
export function useLedgerTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>(LedgerTransactionsDocument, options);
        }
export type LedgerTransactionsQueryHookResult = ReturnType<typeof useLedgerTransactionsQuery>;
export type LedgerTransactionsLazyQueryHookResult = ReturnType<typeof useLedgerTransactionsLazyQuery>;
export type LedgerTransactionsSuspenseQueryHookResult = ReturnType<typeof useLedgerTransactionsSuspenseQuery>;
export type LedgerTransactionsQueryResult = Apollo.QueryResult<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>;
export const DownloadLedgerTransactionsDocument = gql`
    query DownloadLedgerTransactions($filter: LedgerTransactionsFilter) {
  downloadLedgerTransactions(filter: $filter) {
    fileContent
    filename
    mimeType
  }
}
    `;

/**
 * __useDownloadLedgerTransactionsQuery__
 *
 * To run a query within a React component, call `useDownloadLedgerTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadLedgerTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadLedgerTransactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDownloadLedgerTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>(DownloadLedgerTransactionsDocument, options);
      }
export function useDownloadLedgerTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>(DownloadLedgerTransactionsDocument, options);
        }
export function useDownloadLedgerTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>(DownloadLedgerTransactionsDocument, options);
        }
export type DownloadLedgerTransactionsQueryHookResult = ReturnType<typeof useDownloadLedgerTransactionsQuery>;
export type DownloadLedgerTransactionsLazyQueryHookResult = ReturnType<typeof useDownloadLedgerTransactionsLazyQuery>;
export type DownloadLedgerTransactionsSuspenseQueryHookResult = ReturnType<typeof useDownloadLedgerTransactionsSuspenseQuery>;
export type DownloadLedgerTransactionsQueryResult = Apollo.QueryResult<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>;
export const GetMyUserDocument = gql`
    query GetMyUser {
  getMyUser {
    age
    email
    gender
    id
    name
    phoneNumber
  }
}
    `;

/**
 * __useGetMyUserQuery__
 *
 * To run a query within a React component, call `useGetMyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyUserQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>(GetMyUserDocument, options);
      }
export function useGetMyUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>(GetMyUserDocument, options);
        }
export function useGetMyUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>(GetMyUserDocument, options);
        }
export type GetMyUserQueryHookResult = ReturnType<typeof useGetMyUserQuery>;
export type GetMyUserLazyQueryHookResult = ReturnType<typeof useGetMyUserLazyQuery>;
export type GetMyUserSuspenseQueryHookResult = ReturnType<typeof useGetMyUserSuspenseQuery>;
export type GetMyUserQueryResult = Apollo.QueryResult<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>;
export const UpdateMyPasswordDocument = gql`
    mutation UpdateMyPassword($newPassword: String!, $oldPassword: String!) {
  updateMyPassword(newPassword: $newPassword, oldPassword: $oldPassword) {
    id
  }
}
    `;
export type UpdateMyPasswordMutationFn = Apollo.MutationFunction<Types.UpdateMyPasswordMutation, Types.UpdateMyPasswordMutationVariables>;

/**
 * __useUpdateMyPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateMyPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyPasswordMutation, { data, loading, error }] = useUpdateMyPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      oldPassword: // value for 'oldPassword'
 *   },
 * });
 */
export function useUpdateMyPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMyPasswordMutation, Types.UpdateMyPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMyPasswordMutation, Types.UpdateMyPasswordMutationVariables>(UpdateMyPasswordDocument, options);
      }
export type UpdateMyPasswordMutationHookResult = ReturnType<typeof useUpdateMyPasswordMutation>;
export type UpdateMyPasswordMutationResult = Apollo.MutationResult<Types.UpdateMyPasswordMutation>;
export type UpdateMyPasswordMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMyPasswordMutation, Types.UpdateMyPasswordMutationVariables>;
export const UpdateMyUserDocument = gql`
    mutation UpdateMyUser($age: Int, $email: String, $gender: String, $name: String, $phoneNumber: String) {
  updateMyUser(
    updateUserDto: {age: $age, email: $email, gender: $gender, name: $name, phoneNumber: $phoneNumber}
  ) {
    id
  }
}
    `;
export type UpdateMyUserMutationFn = Apollo.MutationFunction<Types.UpdateMyUserMutation, Types.UpdateMyUserMutationVariables>;

/**
 * __useUpdateMyUserMutation__
 *
 * To run a mutation, you first call `useUpdateMyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyUserMutation, { data, loading, error }] = useUpdateMyUserMutation({
 *   variables: {
 *      age: // value for 'age'
 *      email: // value for 'email'
 *      gender: // value for 'gender'
 *      name: // value for 'name'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateMyUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMyUserMutation, Types.UpdateMyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMyUserMutation, Types.UpdateMyUserMutationVariables>(UpdateMyUserDocument, options);
      }
export type UpdateMyUserMutationHookResult = ReturnType<typeof useUpdateMyUserMutation>;
export type UpdateMyUserMutationResult = Apollo.MutationResult<Types.UpdateMyUserMutation>;
export type UpdateMyUserMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMyUserMutation, Types.UpdateMyUserMutationVariables>;